import { render, staticRenderFns } from "./SmsTaskList.vue?vue&type=template&id=53696c4b"
import script from "./SmsTaskList.vue?vue&type=script&lang=js"
export * from "./SmsTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports